import React from 'react'
import { AppointmentItemMulti } from './AppointmentItem';
import { momentTimezone } from 'utils/time';
import { sortBy } from 'lodash';
import { CalendarAppointment } from 'types/models';

interface MultiAppointmentProps {
  data: CalendarAppointment[];
  headerData?: unknown; // passed by CalendarItem but unused here
  onViewAppointmentDetail?: (args: { id: string; disabled?: boolean }) => void;
}

const MultiAppointment = ({ data, onViewAppointmentDetail }: MultiAppointmentProps) => {
  const appointments = React.useMemo(() => sortBy(data, o => momentTimezone(o.startTime)), [data]);
  return (
    <div className='multiple-appointment-item-container'>
      {appointments.map(o => (
        <AppointmentItemMulti key={o.id} data={o} multiple onViewDetail={onViewAppointmentDetail} />
      ))}
    </div>
  )
}

export default MultiAppointment;
